import script from "./RecipeEdit.vue?vue&type=script&setup=true&lang=js"
export * from "./RecipeEdit.vue?vue&type=script&setup=true&lang=js"

import "./RecipeEdit.vue?vue&type=style&index=0&id=67176162&lang=scss&scoped=true"

import exportComponent from "../../../.yarn/__virtual__/vue-loader-virtual-cc52297f69/2/root/.yarn/berry/cache/vue-loader-npm-17.4.2-00674d01e5-10c0.zip/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-67176162"]])

export default __exports__